import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BlackBar, TabTitle, PageLinkButton } from './page_link.styles';
export const PageLink = ({ title, onClick, active }) => {
    return (_jsxs(PageLinkButton, { "data-testid": `${title.toLowerCase()}-tab-container-button`, onClick: onClick, children: [_jsx(TabTitle, { active: active, size: "xlarge", bold: true, children: title }), _jsx(BlackBar, { active: active })] }));
};
//# sourceMappingURL=page_link.js.map